import { AssetPerformanceDetailModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/AssetPerformanceDetailModel";
import { PerformanceDetailsModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/PerformanceDetailsModel";
import { PerformanceIncomeModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/PerformanceIncomeModel";
import { ProductGraphData } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/ProductGraphData";
import { ProductPerformanceDetailModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/ProductPerformanceDetailModel";
import { RealisedGainLossDetailModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/RealisedGainLossDetailModel";
import { UnRealisedGainLossDetailModel } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Performance/UnRealisedGainLossDetailModel";
import { SingleDataStore } from "../../../../../../../Shared/Stores/SingleDataStore";
import { SingleDataStoreDispacher } from "../../../../../../../Shared/Stores/SingleDataStoreDispacher";

export const PortfolioDashboardPerformanceGraphDispatcher = new SingleDataStoreDispacher<ProductGraphData[]>();
export const PortfolioDashboardPerformanceGraphStore = new SingleDataStore<ProductGraphData[]>(
    PortfolioDashboardPerformanceGraphDispatcher
);

export const PortfolioDashboardPerformanceDetailDispatcher = new SingleDataStoreDispacher<
    IProductPerformanceDetailModel[]
>();
export const PortfolioDashboardPerformanceDetailStore = new SingleDataStore<IProductPerformanceDetailModel[]>(
    PortfolioDashboardPerformanceDetailDispatcher
);

export const PortfolioDashboardPerformanceRealisedGainLossDispatcher = new SingleDataStoreDispacher<
    RealisedGainLossDetailModel[]
>();
export const PortfolioDashboardPerformanceRealisedGainLossStore = new SingleDataStore<RealisedGainLossDetailModel[]>(
    PortfolioDashboardPerformanceRealisedGainLossDispatcher
);

export const PortfolioDashboardPerformanceUnRealisedGainLossDisptcher = new SingleDataStoreDispacher<
    UnRealisedGainLossDetailModel[]
>();
export const PortfolioDashboardPerformanceUnRealisedGainLossStore = new SingleDataStore<
    UnRealisedGainLossDetailModel[]
>(PortfolioDashboardPerformanceUnRealisedGainLossDisptcher);

export const PortfolioDashboardPerformanceIncomeDispatcher = new SingleDataStoreDispacher<PerformanceIncomeModel>();
export const PortfolioDashboardPerformanceIncomeStore = new SingleDataStore<PerformanceIncomeModel>(
    PortfolioDashboardPerformanceIncomeDispatcher
);

export interface IProductPerformanceDetailModel extends ProductPerformanceDetailModel {
    ModelAssetPerformanceDetail: IAssetPerformanceDetailModel[];
    OPIAssetPerformanceDetail: IAssetPerformanceDetailModel[];
    NonModelAssetPerformanceDetail: IAssetPerformanceDetailModel[];
}

export interface IAssetPerformanceDetailModel extends AssetPerformanceDetailModel {
    PerformanceDetailsWithFlag: IPerformanceDetailsModel[];
}

export interface IPerformanceDetailsModel extends PerformanceDetailsModel {
    isModel: boolean;
    isToogle?: boolean;
    underlyingModel?: AssetPerformanceDetailModel[];
}
